module.exports = __webpack_public_path__ + "static/media/biometric attendance.58c2ddfd.svg";